export async function getOpenAIAPIKey(): Promise<string | null> {
  // Try client-side env var first
  if (process.env.NEXT_PUBLIC_OPENAI_API_KEY) {
    return process.env.NEXT_PUBLIC_OPENAI_API_KEY;
  }

  // If we had a server-side only key, we'd fetch it here via a server action or API route.
  // For now, assume client env var is set or return null.
  return null;
}
